// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EG-z","twoColumnImage":"FG-z"};